import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { EcplImageViewerComponent } from './ecpl-image-viewer.component';
import { ImagePreviewDirective } from './image-preview.directive';

@NgModule({
  declarations: [EcplImageViewerComponent],
  imports: [
    CommonModule,
    TranslatePipe,
    TranslateDirective,
    ImagePreviewDirective
  ],
  exports: [EcplImageViewerComponent, ImagePreviewDirective]
})
export class EcplImageViewerModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: EcplImageViewerModule
    };
  }
}
